import { Box, Typography, Button, Snackbar, Alert } from '@mui/material';
import { useEffect, useState } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

export function ErrorBoundary({ children }) {
  const [snackbar, setSnackbar] = useState({ open: true, msg: '', severity: 'error' })
  return (
    <ReactErrorBoundary
      fallbackRender={({ error, componentStack, resetErrorBoundary }) => {
        return (
          <>
            <Snackbar
              open={snackbar.open}
              autoHideDuration={6000}
              onClose={() => setSnackbar({ open: false, severity: "", msg: "" })}
            >
              <Alert
                onClose={() => setSnackbar({ open: false, severity: "", msg: "" })}
                severity={snackbar.severity}
                sx={{ width: "100%" }}
              >
                {snackbar.msg}
              </Alert>
            </Snackbar>
            <Box
              sx={{
                p: 4,
                bg: 'red',
                fontSize: '1.5rem',
                textAlign: 'center',
                width: '100%',
                borderRadius: '0.5rem',
                boxShadow: '0 0.5rem 1rem rgba(0,0,0,0.1)'
              }}
            >

              <Typography variant="h4">Something went wrong</Typography>
              <Typography variant="body1">{componentStack}</Typography>
              <Button variant="contained" color="primary" onClick={() => {
                resetErrorBoundary()
              }}>
                Try again
              </Button>
            </Box>
          </>
        )
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
}
